/**
 * Frontend JavaScript for MR Blocks Carousel using Splide.js
 */

document.addEventListener("DOMContentLoaded", function () {
	console.log("MR Blocks Carousel: DOM loaded, initializing carousels...");

	// Function to initialize a single carousel
	function initializeCarousel(carouselElement) {
		console.log("Initializing carousel:", carouselElement);

		// Get the splide element
		const splideElement = carouselElement.querySelector(".splide");
		if (!splideElement) {
			console.warn("No .splide element found in carousel");
			return;
		}

		// Check if already initialized
		if (splideElement.classList.contains("is-initialized")) {
			console.log("Carousel already initialized, skipping");
			return;
		}

		// Get configuration from data attribute
		let config = {};
		try {
			const configData = carouselElement.getAttribute("data-splide");
			if (configData) {
				config = JSON.parse(configData);
			}
		} catch (error) {
			console.warn("Error parsing carousel configuration:", error);
		}

		// Default configuration
		const defaultConfig = {
			type: "loop",
			perPage: 1,
			gap: 20,
			padding: 0,
			autoplay: false,
			pauseOnHover: true,
			pauseOnFocus: true,
			easing: "ease",
			arrows: true,
			pagination: true,
			breakpoints: {
				768: {
					perPage: 1,
					gap: 10,
					padding: 0, // Will be updated after config merge
				},
			},
		};

		// Merge configurations
		const finalConfig = { ...defaultConfig, ...config };

		// Handle centerMode with Splide's padding option
		if (config.focus === 0 && config.rewind === false) {
			// Calculate left padding for centerMode
			const screenWidth = window.innerWidth;
			const preferredWidth = screenWidth * 0.8; // 80vw
			const containerWidth = Math.max(1260, Math.min(preferredWidth, 1440));
			const leftPadding = Math.max(0, (screenWidth - containerWidth) / 2);

			console.log("CenterMode detected - using Splide padding option");
			console.log("leftPadding:", leftPadding);

			// Use Splide's padding option for centerMode
			finalConfig.padding = {
				left: leftPadding,
				right: 0,
			};
		}

		// Add tablet breakpoint with proper logic after merge
		const tabletPerPage =
			finalConfig.perPage && finalConfig.perPage > 2
				? 2
				: finalConfig.perPage || 1;

		// Calculate responsive padding/peek values
		const originalPadding = finalConfig.padding || 0;
		const tabletPadding =
			originalPadding > 0 ? Math.max(originalPadding * 0.6, 10) : 0;
		const mobilePadding =
			originalPadding > 0 ? Math.max(originalPadding * 0.3, 5) : 0;

		finalConfig.breakpoints[1024] = {
			perPage: finalConfig.autoWidth ? undefined : tabletPerPage,
			gap: finalConfig.gap > 15 ? 15 : finalConfig.gap || 20,
			padding: tabletPadding,
		};

		// Update mobile breakpoint with responsive padding
		finalConfig.breakpoints[768] = {
			perPage: 1,
			gap: finalConfig.gap > 10 ? 10 : finalConfig.gap || 20,
			padding: mobilePadding,
		};

		console.log("Carousel configuration:", finalConfig);

		// Wait for Splide.js to be available
		function waitForSplide() {
			if (typeof window.Splide !== "undefined") {
				console.log("Splide.js is available, creating carousel instance");
				try {
					// Create and mount the Splide instance
					const splide = new window.Splide(splideElement, finalConfig);
					splide.mount();

					// Mark as initialized
					splideElement.classList.add("is-initialized");

					// Handle window resize for centerMode dynamic padding
					if (config.focus === 0 && config.rewind === false) {
						const handleResize = () => {
							const screenWidth = window.innerWidth;
							const preferredWidth = screenWidth * 0.8;
							const containerWidth = Math.max(
								1260,
								Math.min(preferredWidth, 1440),
							);
							const leftPadding = Math.max(
								0,
								(screenWidth - containerWidth) / 2,
							);

							// Refresh carousel with new padding
							try {
								splide.destroy();
								const newConfig = {
									...finalConfig,
									padding: { left: leftPadding, right: 0 },
								};
								const newSplide = new window.Splide(splideElement, newConfig);
								newSplide.mount();
								splideElement.splide = newSplide;
							} catch (error) {
								console.warn("Error updating centerMode padding:", error);
							}
						};

						window.addEventListener("resize", handleResize);

						// Store cleanup function
						splideElement._paddingCleanup = () => {
							window.removeEventListener("resize", handleResize);
						};
					}

					console.log("Carousel initialized successfully");
				} catch (error) {
					console.error("Error initializing Splide carousel:", error);
				}
			} else {
				console.log("Splide.js not yet available, retrying...");
				setTimeout(waitForSplide, 100);
			}
		}

		waitForSplide();
	}

	// Initialize all carousels on the page
	function initializeAllCarousels() {
		const carousels = document.querySelectorAll(".mr-carousel");
		console.log(`Found ${carousels.length} carousel(s) to initialize`);

		carousels.forEach((carousel, index) => {
			console.log(`Initializing carousel ${index + 1}/${carousels.length}`);
			initializeCarousel(carousel);
		});
	}

	// Initialize carousels
	initializeAllCarousels();

	// Re-initialize carousels when new content is loaded (for AJAX/dynamic content)
	const observer = new MutationObserver(function (mutations) {
		mutations.forEach(function (mutation) {
			if (mutation.type === "childList") {
				mutation.addedNodes.forEach(function (node) {
					if (node.nodeType === Node.ELEMENT_NODE) {
						// Check if the added node is a carousel or contains carousels
						const carousels = node.classList?.contains("mr-carousel")
							? [node]
							: node.querySelectorAll?.(".mr-carousel") || [];

						if (carousels.length > 0) {
							console.log(
								`Found ${carousels.length} new carousel(s), initializing...`,
							);
							carousels.forEach(initializeCarousel);
						}
					}
				});
			}
		});
	});

	// Start observing
	observer.observe(document.body, {
		childList: true,
		subtree: true,
	});

	console.log("MR Blocks Carousel: Initialization complete");
});

// Also handle ACF and other dynamic content loaders
if (typeof window.acf !== "undefined") {
	window.acf.addAction("render_block_preview", function () {
		setTimeout(function () {
			const carousels = document.querySelectorAll(".mr-carousel");
			carousels.forEach(function (carousel) {
				const splideElement = carousel.querySelector(".splide");
				if (
					splideElement &&
					!splideElement.classList.contains("is-initialized")
				) {
					const event = new Event("DOMContentLoaded");
					document.dispatchEvent(event);
				}
			});
		}, 100);
	});
}
